module.exports = __webpack_public_path__ + "img/mountain_top.aac06394.svg";